import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { selectConfig, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_COMPANY, REQUEST_VIES_CHECK } from '../../constants';
import { createCompany } from '../../actions';
import { selectNewCompany } from '../../selectors';
import { Loader } from '../../../../components/Loader';

import { getDate, isWithInstallation } from '../../../Vehicles/helpers';
import { REQUEST_VIES_CHECK_HISTORY } from '../../constants';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import cn from 'classnames';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './FourthAnalyseStep.module.css';
import { changeVehicleFilter, updateVehicleFilter, updateWithFetchVehicleFilter } from '../../../Vehicles/actions';
import { REQUEST_VEHICLES } from '../../../Vehicles/constants';
import { AnalyseVehicles } from './AnalyseVehicles';

const Container = styled.div`
  width: 100%;
  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
  }

  .vies-block {
    overflow-y: auto;
    width: 30%;
    max-height: 150px;
  }

  .button-block {
    margin: -6px;
    margin-right: 15px;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class AnalyseStep4Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.change(this.props.company_id, this.props.values?.name);
  }

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container className={styles.container}>
        <VBox className={cn('cols', styles.containerCol)}>
          <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
            <HBox flip={window.innerWidth < 769} className={styles.wrapper}>
              <div className={styles.containerFlex}></div>

              <div className={styles.containerFlex}></div>
            </HBox>
            <AnalyseVehicles />

            <div className={cn('d-flex gap-2 justify-content-end mt-2', styles.buttonContainerBottom)}>
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)}>
                {this.lbl('previous')}
              </ButtonComponent>
              <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)} small>
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          </div>
        </VBox>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY]),
    workViesHistory: selectWork(`${REQUEST_VIES_CHECK_HISTORY}-${ownProps.company_id}`),
    workViesCheck: selectWork(REQUEST_VIES_CHECK),
    values: selectNewCompany(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      dispatch(createCompany(properties, options, callback));
    },

    change(value, label = '') {
      dispatch(
        updateWithFetchVehicleFilter({
          key: 'invoice_outgoing_company_id',
          value: [value.toString().toLowerCase()],
          label: [label],
          type: 'single',
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AnalyseStep4 = compose(withConnect, withRouter)(AnalyseStep4Comp);
